(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('languages', ['$filter', 'SharedAgendaService', 'AdministrationService', LanguagesDirectiveFn]);


    /* select box for languages */
    function LanguagesDirectiveFn($filter, SharedAgendaService, AdministrationService) {
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                languages: '=?',
                model: '=',
                append: '=?',
            },
            replace: true,
            templateUrl: '/app/global/templates/rf-global-languages.template.html'
        };
        return directive;

        function link(scope, element) {
            // if no language-list available -> load 
            if (scope.languages === undefined || scope.languages === null) {
                AdministrationService.languages().then(function (result) {
                    scope.languages = result;
                    activate();
                });
            } // if
            else { activate(); }

            // preselect language of current user if none is selected
            function activate() {
                if (scope.model !== null && typeof scope.model !== 'undefined') { return; }
                if (typeof scope.append === 'undefined') {
                    scope.append = false;
                }

                var agenda = SharedAgendaService.currentUser();
                // current agenda user
                if (agenda !== null && typeof agenda.languageId !== 'undefined' && scope.languages.length > 0) {
                    // get language by id (if available)
                    var liste = $filter('filter')(scope.languages, { 'id': agenda.languageId }, true);
                    if (liste && liste.length > 0) {
                        scope.model = liste[0];
                        scope.used = true;
                    } //if
                    else {
                        // preselect first in array
                        scope.model = scope.languages[0];
                    } // else
                } //if
            }

            // select language
            scope.select = function (language) {
                scope.model = language;
            };
        }
    }

})();